import React from "react";
import Synthesizer from "./Synthesizer";

function Landing() {
  return (
    <div className="landing">
      <Synthesizer />
    </div>
  );
}

export default Landing;
